export default {
    i18n: {
        "day": "天",
        "Device Information": "設備資訊",
        "handset": "手柄",
        "Access Denied.": "開門失敗",
        "Date Time": "時間",
        "name": "註冊名",
        "Fingerprint": "指紋",
        "tamperAlarm": "防拆告警",
        "Device Name": "設備名",
        "Http": "http",
        "Volume": "音量",
        "Card": "卡",
        "minutes": "分鐘",
        "timezone": "時區",
        "Are you sure you want to delete this device?": "您確定要刪除這個設備嗎？",
        "Attendance Point Name": "考勤點名稱",
        "Mac": "蘋果電腦",
        "confirmToDeleteIt?": "你確定要刪除嗎？",
        "captureLogs": "截圖記錄",
        "Doors": "門",
        "All Doors": "所有門",
        "Lock List": "鎖列表",
        "Link Device Relay": "鏈接設備繼電器",
        "Added Successfully!": "成功添加！",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "當鎖與繼電器鏈接時，觸發繼電器時將解鎖鎖定。",
        "Adding...": "新增中...",
        "Please try again 24 hours later.": "24小時後請重試。",
        "Action": "操作",
        "unlock": "開門",
        "Address": "地址",
        "Owner": "所屬者",
        "Failed": "失敗",
        "Timeout": "對外供電時間",
        "Response": "操作結果",
        "caller": "主叫方",
        "receiver": "接收",
        "doorLogs": "開門記錄",
        "callHistory": "呼叫記錄",
        "UID": "UID",
        "Call Type": "呼叫類型",
        "Code": "密碼",
        "User": "用戶",
        "Device List": "設備列表",
        "Model": "型號",
        "Time": "時間",
        "Company": "公司",
        "Property Managers": "物業管理員",
        "Current Version": "當前版本",
        "indoorMonitor": "室內機",
        "guardPhone": "管理機",
        "close": "關閉",
        "Success": "成功",
        "URL": "鏈接",
        "Please select a device.": "請選擇一個設備",
        "Password is too weak.": "密碼太簡單",
        "Company is required.": "請輸入公司名",
        "Your account is not activated, please contact your service provider.": "您的帳戶尚未激活，請與您的服務供應商聯絡。",
        "Language": "語言",
        "Face": "人臉",
        "Please set at least one access type.": "請至少設置一種類型。",
        "Please contact your service provider to activate this advanced feature.": "請聯絡您的服務供應商以激活此高級功能。",
        "Community name": "社區名字",
        "Please enable PM App first.": "請先開啟物業管理員App",
        "Username": "用戶名",
        "Change Log": "更改日誌",
        "Assign": "分配",
        "Floor": "樓層",
        "Link Device": "鏈接設備",
        "Accessible Floors": "可達樓層 ",
        "Upgrade": "升級",
        "Function": "功能",
        "callDuration": "通話時間",
        "No": "無",
        "Verification Code": "驗證碼",
        "Expiration Time": "到期時間",
        "PIN": "密碼",
        "MAC": "MAC",
        "Building": "樓棟",
        "APT": "房間",
        "ID": "ID",
        "Name": "名稱",
        "activities": "使用記錄",
        "Obtain": "獲取",
        "call": "呼叫",
        "Group Call": "群呼",
        "Delete": "刪除",
        "Yes": "是",
        "Door Release PIN": "開門密碼",
        "Email": "電子信箱",
        "Mobile Number doesn\'t exist.": "手機號碼不存在。",
        "Tips": "提示",
        "Password": "密碼",
        "The end time cannot be earlier than the start time.": "結束時間不可早於開始時間!",
        "Back": "返回",
        "File format error.": "文件格式錯誤。",
        "motionDetection": "移動偵測",
        "You are trying too often, please try again in 5 minutes": "由於您嘗試次數過多，請在5分鐘後再次嘗試",
        "User name too long.": "用戶名太長。",
        "This MAC address is redirected on RPS.": "此MAC地址在RPS上重定向",
        "No Answer": "未接聽",
        "failedToUnlock": "開門失敗",
        "visitor": "訪客",
        "yesterday": "昨天",
        "Too large data! Please first export the data before %s first,thanks.": "請先導出 %s 之前的數據",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "請檢查是否有任何未付款的訂單。如果沒有，請聯絡您的服務供應商",
        "lock": "上鎖",
        "open": "開門",
        "The PersonalAccount is not active.": "帳戶未開通。",
        "You cannot link an account that already link other accounts.": "您無法鏈接已經具有多個站點的帳戶。",
        "You cannot link multiple property manager accounts under the same installer account.": "您無法在同一安裝人員帳戶下連結多個物業經理帳戶。",
        "You cannot link to the currently logged in account.": "您無法連結到目前登入的帳戶。",
        "nfc": "NFC",
        "Delete Device": "刪除設備",
        "date": "日期",
        "Device deleted successfully": "設備成功刪除",
        "Failed to delete device": "無法刪除設備",
        "Are you sure you want to cancel?": "您確定要取消嗎？",
        "Unlimited": "無限",
        "Password Incorrect.": "密碼錯誤。",
        "deliverySystemVerification": "快遞驗證",
        "auto": "自動",
        "Group": "群組",
        "None": "無",
        "Upgrading...": "正在陞級。。。",
        "amenityReservation": "公共場所預約",
        "idAccess": "ID訪問",
        "RF Card": "門禁卡",
        "exitButton": "開門按鈕",
        "Please select at least one item.": "請選擇至少一項。",
        "The ID can contain only digits and letters, up to 32 characters.": "ID只能包含數字和字母，最多32個字符。",
        "The PIN is not available.": "密碼不可用",
        "Change WiFi": "更換WiFi",
        "Phone number": "電話號碼",
        "Invalid {0}.": "{0}無效",
        "{0} already exists.": "{0}已經存在。",
        "Operation failed!": "操作失敗！",
        "Failed to get data.": "無法獲取數據。",
        "You do not have the necessary permissions to perform this operation.": "您沒有執行此操作的必要權限。",
        "You can only import one template at a time in the current site.": "您只能在當前站點中一次導入一個模板。",
        "Delivery name": "快遞員授權名稱",
        "MAC address not in the MAC library.": "MAC地址未在MAC庫中",
        "Please delete devices under this building.": "請刪除該建築物下的設備。",
        "The start time cannot be later than the end time.": "開始時間不能晚於結束時間。",
        "emergency action type": "緊急行動類型",
        "Only 1000 data items can be imported at a time.": "一次只能導入1000個數據項。",
        "The password is too short.": "密碼太短。",
        "The data has been updated. Please refresh the page and try again.": "數據已更新，請刷新頁面並重試。",
        "AutoP length must be less 2048 bytes.": "AutoP命令長度需小於2048位元組",
        "File Check Failed": "文件檢查失敗",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "管理員賬號已過期，請聯繫您的服務提供商。",
        "iqPinVerificationFailed": "IQ PIN校驗失敗。",
        "accountBlacklisted": "賬號被拉黑。",
        "outsideAuthorizedTime": "不在有效時間內。",
        "network group": "網絡組",
        "Company name": "公司名稱",
        "Group name": "群組名稱",
        "relay": "門",
        "motionTime": "移動偵測時間",
        "motionType": "移動偵測類型",
        "postalCode": "郵遞區號",
        "floor format": "樓層格式",
        "mobilePhone": "手機號",
        "time format": "時間格式",
        "security relay": "安全繼電器",
        "Param": "參數",
        "Offline Code": "離線密碼",
        "Add akubela Smart Locks": "添加Akubela智慧鎖",
        "Module Version": "模塊版本",
        "Lock Body Version": "鎖體版本",
        "Available Version": "可用版本",
        "Please wake up the lock screen and then upgrade.": "請喚醒鎖屏，然後陞級。",
        "This process will take some time, please be patient.": "這個過程需要一些時間，請耐心等待",
        "Please confirm that the WiFi network is functioning properly.": "請確認WiFi網絡是否正常",
        "Please wake up the lock screen.": "請喚醒鎖屏。",
        "This lock has already been added to another apartment.": "這把鎖已經被添加到另一個房間",
        "This lock has already been added to the apartment.": "這把鎖已經加到房間",
        "Pin Code": "Pin碼",
        "Too many failed attempts, please try again in a few minutes.": "失敗的嘗試太多，請在幾分鐘後重試",
        "Login Account": "登入帳號",
        "Same account cannot login in different ins.": "同一帳戶不能登入不同的安裝商。",
        "Lock Name": "鎖名稱",
        "Smart Locks": "智能鎖",
        "Add Smart Lock": "添加智慧鎖",
        "The selected duration cannot be more than one year.": "選的的時長不能超過一年",
        "The end time of the break time cannot be later than the end work time.": "休息時間的結束時間不能晚於結束工作時間。",
        "The start time of the break time cannot be earlier than the start work time.": "休息時間的開始時間不能早於開始工作時間。",
        "The end time of the valid check time cannot be earlier than the end work time.": "有效打卡時間的結束時間不能早於結束工作時間。",
        "The start time of the valid check time cannot be later than the start work time.": "有效打卡時間的開始時間不能晚於開始工作時間。",
        "Deleting failed. The timetable is used by a shift.": "時間表已被班次使用中，删除失敗。",
        "Deleting failed. The shift is in use.": "班次正在使用中，删除失敗。",
        "Deleting failed. The leave type is in use.": "休假類型正在使用中，删除失敗。",
        "Valid time conflicts with an existing schedule.": "已存在的排班和有效時間衝突。",
        "The timing for multiple schedules must not coincide.": "多個時間表的時間不能重疊。",
        "Attendance Log": "記錄",
        "Added Failed!": "添加失敗！",
        "Setting WiFi": "設定WiFi",
        "License Plate": "車牌",
        "key": "密碼",
        "IQ Offline.": "IQ 離線",
        "{0}Unlock": "{0}解鎖",
        "automatically": "自動",
        "manually": "手動",
        "Video Storage": "視頻存儲",
        "Device(s) for Video Storage": "視頻儲存設備",
        "The amount of exported data is too large. Please export it in batches.": "導出的數據量過大，請分批導出",
        "Auto-record video when door unlocks": "開門時自動錄製視頻",
        "Auto-record video during calls": "通話時自動錄製視頻",
        "Manual video recording in monitoring": "監控中手動錄製視頻",
        "Saved for 30days/60days/90days": "保存30天/60天/90天",
        "To subscribe, please contact your provider for activation.": "如需訂閱，請聯繫您的服務提供商進行激活。",
        "Saved for {0}days": "保存{0}天",
        "Subscribed Plan": "訂閱計劃",
        "Supported Devices: {0}": "支持設備：{0}",
        "{0}Lock": "{0} 關鎖",
        "Video Saving": "視頻保存",
        "Download Completed!": "下載完成!",
        "Fail to download.": "下載失敗。",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "刪除失敗！物業管理員已綁定到RentManager賬號，您應該首先刪除它。",
        "No log to be exported.": "導出記錄無數據",
        "capture&Video": "截圖&視頻",
        "packageDetection": "包裹檢測",
        "Time format is invalid.": "時間格式無效。",
        "No permission to export logs of this type.": "匯出該類型日誌沒有許可權。",
        "Project type is invalid.": "項目類型無效",
        "Salto Account Blocked.": "Salto帳號被鎖定",
        "Remote open not in access group.": "不在許可權組無法遠程開門",
        "SIP Account required.": "SIP帳號是必填項",
        "The PIN must be {0} digits.": "PIN必須為{0}位數字。",
        "gatewayConnectionUnavailable": "閘道連線不可用。",
        "Invalid Username or Password": "使用者名稱或密碼錯誤。",
        "Account already linked to another user.": "帳號已綁定至其他帳號",
        "The account has been added by another user.": "該帳戶已被其他使用者添加",
        "Failed to add. This user already has 5 license plates.": "添加失敗，該用戶已擁有5個車牌",
        "Please at least select a door.": "請至少選擇一個門。",
        "UHF Card": "UHF卡",
        "personnel": "人員",
        "Parking Lot Name": "停車場名",
        "Controlled Relay": "控制的繼電器",
        "No Permission": "無權限",
        "Please ensure that all doors in the project are activated at the same time.": "請同時激活項目中的所有門",
        "gatewayBusy": "閘道忙碌",
        "Please set the perimeter door group first.": "請先設置邊界門",
        "Please ensure that all doors in the project are renewed at the same time.": "請確保項目中的所有門同時續費",
        "When lockdown is on, the controlled relay cannot be modified.": "鎖定狀態下，不能修改繼電器",
        "DetectionLogs": "檢測日誌",
        "packageIn": "包裹放入",
        "packageOut": "包裹拿出",
        "View Progress": "查看進度",
        "Check if the WiFi is operating on the 2.4GHz band.": "請確認WiFi是否在2.4GHz頻段運作。",
        "Verify that the WiFi password is correct.": "請確認WiFi密碼是否正確。",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "請確保在設定熱點期間連接到正確的設備熱點。",
        "Offline Code Unlock": "離線密碼開鎖",
        "Salto Token Expired.": "Salto令牌已過期。",
        "Lock Offline": "鎖已離線",
        "identity information! Please login again": "身份資訊！請重新登入",
        "Email is required.": "必須填寫電子郵件。",
        "Mobile number is required.": "請輸入手機號碼。",
        "You can\'t make payments for offices in different time zones.": "您無法為不同时區的辦公室進行付款。",
        "The current scheduling staff exceeds 200 people.": "目前排班人員已超過200人。",
        "param": "參數",
        "Invalid UserName or Password": "無效的使用者名稱或密碼",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "您的 Salto KS 帳戶無權限修改鎖的名稱。",
        "Owner is required.": "必須填寫擁有者。",
        "Office is required.": "需要辦公室。",
        "PIN or RF Card is required.": "需要輸入PIN碼或RF卡。",
        "RF card": "射頻卡",
        "Personnel is required.": "需要人員。",
        "email address": "電子郵件地址",
        "mobile number": "手機號碼",
        "The length must be less than 32 characters.": "長度必須少於32個字元。",
        "The length must be less than 256 characters.": "長度必須少於256個字元。",
        "Access Group is required.": "需要權限組。",
        "Device is required.": "需要裝置。",
        "Admin is required.": "需要管理員。",
        "Mobile number": "手機號碼",
        "schedules": "時間表",
        "Timetable name": "時間表名稱",
        "Shift name": "班次名稱",
        "Leave type": "假別種類",
        "recheck in time": "重新簽到時間",
        "recheck out time": "重新簽退時間",
        "The building name": "樓棟名稱",
        "Building is required.": "需要樓棟。",
        "selection, The same reader cannot be set for both entry and exit": "選擇，入口和出口不能設置相同的讀卡器",
        "Door number": "門號",
        "door input cannot be selection duplicated.": "門輸入介面不能被重複選擇。",
        "Group is required.": "必須填寫群組。",
        "Title can contain up to 32 characters.": "標題最多可包含32個字元。",
        "Content can contain up to 1024 characters.": "內容最多可包含1024個字元。",
        "Content can contain up to 64 characters.": "內容最多可包含64個字元。",
        "Report is required.": "需要提交報告。",
        "ID is required.": "需要提供身分證。",
        "The office does not exist.": "該辦公室不存在。",
        "Office name": "辦公室名稱",
        "The Temp Key does not exist.": "臨時密鑰不存在。",
        "autolock time": "自動鎖定時間",
        "The User does not exist.": "該用戶不存在。",
        "The Installer does not exist.": "該安裝商不存在。",
        "The Project does not exist.": "該專案不存在。",
        "The Distributor does not exist.": "該代理商不存在。",
        "The Community Device does not exist.": "社區設備不存在。",
        "The Property Manager does not exist.": "物業管理員不存在。",
        "The Sub Distributor does not exist.": "該子代理商不存在。",
        "The Single Slave does not exist.": "單一住戶不存在。",
        "The Property Manager EndUser does not exist.": "該物業管理員終端用戶不存在。",
        "The Family Member does not exist.": "該家庭成員不存在。",
        "Set Failed!": "設置失敗！",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "您已在30分鐘內達到10次存取碼請求的上限，請稍後再試。",
        "This Email doesn\'t exist.": "此電子郵件不存在。",
        "detection type": "檢測類型",
        "Device UUID": "設備 UUID",
        "smart lock device": "智慧鎖裝置",
        "You are trying too often, please try again in 5 minutes.": "您嘗試的次數過多，請在 5 分鐘後重試。",
        "You can only import one file at a time. Please wait for the current import to finish.": "一次只能匯入一個檔案。請等待當前匯入完成。",
        "NVR Name": "NVR名稱",
        "NVR Address": "NVR地址",
        "Stay Alarm": "停留警報",
        "Happended On": "發生於",
        "Edit Milesight NVR": "編輯Milesight NVR",
        "Add Milesight NVR": "新增Milesight NVR",
        "Auto-record video on motion detection, package detection": "運動偵測、包裹偵測時自動錄影",
        "A 7-day free trial is included with your subscription.": "您的訂閱包含7天免費試用。",
        "For service renewal, please reach out to your provider.": "如需續訂服務，請聯繫您的服務供應商。",
        "Allow the Property Manager to view recorded videos": "允許物業管理員檢視錄製影片",
        "Please ensure the WiFi network is working properly.": "請確保WiFi網路正常運作。",
        "Edit akubela Smart Locks": "編輯akubela智慧鎖",
        "Upgraded Successfully!": "升級成功！",
        "Upgraded Failed!": "升級失敗！",
        "Editing...": "正在編輯...",
        "Edited successfully!": "編輯成功！",
        "Edited Failed!": "編輯失敗！",
        "Downloading video...": "正在下載影片...",
        "All Locks": "所有鎖",
        "Select Locks": "選擇鎖",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "akubela智慧鎖連接到網路後，即可使用{0}碼PIN。請注意，同步後PIN可能需要稍等一段時間才會生效。",
        "Please at least select a door or a lock.": "請至少選擇一個門或一把鎖。",
        "This lock has already been added to your apartment.": "此鎖已加入您的房間。",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "此鎖已加入另一個房間，請聯繫您的服務供應商協助。",
        "LockBody Version": "鎖體版本",
        "Two-factor Authentication": "雙重驗證",
        "Monitoring Scope": "監控範圍",
        "Stay Duration": "停留時間",
        "Volume Settings": "音量設定",
        "get card list for lock error": "獲取鎖卡列表錯誤",
        "get card list parse fail": "獲取卡列表解析失敗",
        "get pin list for lock error": "獲取鎖定密鑰列表錯誤",
        "get pin list parse fail": "獲取密鑰列表解析失敗",
        "fingerprint code must be less than 2048 characters or empty.": "指紋代碼必須少於2048個字元或為空。",
        "Personnel not in office.": "人員不在辦公室。",
        "customize form fail.": "自訂表單失敗。",
        "smart lock type error.": "智慧鎖類型錯誤。",
        "invalid client id or secret": "無效的客戶端ID或密鑰",
        "invalid account or password": "無效的帳號或密碼",
        "invalid access token": "存取權杖無效",
        "invalid refresh token": "刷新權杖無效",
        "no permission to access this project": "沒有權限存取此專案",
        "Stay Alarm Time": "停留警報時間",
        "This function only support sl20 lock.": "此功能僅支援sl20鎖。",
        "Json marshal error.": "Json編碼錯誤。",
        "Json unmarshal error.": "Json解碼錯誤。",
        "Illegal request, not added within valid time.": "非法請求，未在有效時間內新增。",
        "invalid nvr type": "無效的nvr類型",
        "project is empty": "專案為空",
        "project type is invalid": "專案類型無效",
        "owner is invalid": "擁有者無效",
        "url is invalid": "url無效",
        "password is invalid": "密碼無效",
        "building is invalid": "建築無效",
        "fail to get data": "獲取資料失敗",
        "invalid allow pm view type": "無效的允許pm檢視類型",
        "Data not exist.": "資料不存在。",
        "cannot find community PrivateKey.": "找不到社區私鑰。",
        "cannot find single PrivateKey.": "找不到單獨私鑰。",
        "The third party not exist.": "第三方不存在。",
        "{0} and indoor monitors/guard phones": "{0}和室內機/管理機",
        "{0} and indoor monitors/guard phones, with phone as backup": "先撥{0}和室內機/管理機，無人接聽再撥手機號",
        "Indoor monitors/guard phones with {0} as backup": "先撥室內機/管理機，無人接聽再撥{0}",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "先撥室內機/管理機，無人接聽再撥{0}，最後撥手機號",
        "{0} Intercom Feature": "{0}對講功能",
        "Capture on {0}": "於{0}截圖",
        "{0} Intercom Feature is not activated or has expired.": "{0}對講功能尚未啟用或已過期",
        "fingerprint code must be equal 1620 characters or empty.": "指紋代碼必須等於1620個字元或為空。",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "為確保升級成功，請先確保鎖的電池電量高於40%後再繼續。",
        "Automatic Locking Time": "自動上鎖時間",
        "WiFi Keep-Alive": "WiFi保活",
        "WiFi Setting": "WiFi設定",
        "Connecting the network...": "正在連接網路...",
        "Set successfully!": "設定成功！",
        "The offline code can be used even if the lock is not connected to WiFi.": "即使鎖沒有連接WiFi，也能使用離線密碼。",
        "Enabling this feature will increase the lock\'s power consumption.": "啟用此功能會增加鎖的耗電量。",
        "Each offline code can only be used once.": "每組離線密碼僅能使用一次。",
        "Receiver Info": "接收者資訊",
        "log id": "登入id",
        "Create HW SN Config Empty SN.": "建立華為SN組態空SN。",
        "The SN": "序號",
        "SN can contain up to 32 characters.": "SN最多可包含32個字元。",
        "Check HW SN Not Found.": "檢查華為SN未找到。",
        "the end user not found": "找不到最終使用者",
        "Family Call": "家庭通話",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "升級期間，所有與鎖相關的功能將暫不可用。",
        "8-digit PIN code starting with \"9\" is invalid!": "以「9」開頭的8位PIN碼無效！",
        "Lock name length must be between 1 and 50": "鎖名稱長度必須介於1到50之間",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "使用市話服務的人員數量不可超過使用 {0} 對講服務的人員數量。",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "擁有市話服務的管理員數量不能超過擁有 {0} 對講服務的管理員數量。",
        "charge type": "收費類型",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "擁有市話服務的人員數量不可超過擁有SmartPlus對講服務的人員數量。",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "擁有市話服務的管理員數量不可超過擁有SmartPlus對講服務的管理員數量。",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "讀卡機不能同時配置為使用韋根和RS485。",
        "parameter error": "參數錯誤",
        "community name already exist": "社區名稱已存在",
        "personnel app without intercom feature number": "無對講功能號碼的人員app",
        "check feature billing charge plan new error": "檢查功能計費收費計劃新錯誤",
        "subscription not found": "未找到訂閱",
        "System setting record not found.": "未找到系統設置記錄。",
        "Smart home not enabled.": "未啟用智慧家庭。",
        "the apt call type value is invalid.": "apt呼叫方式值無效。",
        "the ip call or sip call value is invalid.": "IP呼叫或SIP呼叫值無效。",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "pinCode必須是2-8位數字，但不能是以9開頭的8位數字或為空。",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCard必須是A-F0-9且少於16位或為空。",
        "owner cannot be empty.": "所有者不能為空。",
        "creator cannot be empty.": "創建者不能為空。",
        "the creator type value is invalid": "創建者類型值無效",
        "the IsCreateByPm value is invalid": "IsCreateByPm值無效",
        "the pinCode already exist": "pinCode已存在",
        "the rfCard already exist": "rfCard已存在",
        "license plate is invalid.": "車牌無效。",
        "owner info is invalid.": "所有者資訊無效。",
        "uhf is invalid.": "uhf無效。",
        "time control is invalid.": "時間控制無效。",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "您已達到5個車牌的限制，無法添加",
        "the plate already exist": "車牌已存在",
        "the uhf already exist": "uhf已存在",
        "empty community": "空的社區",
        "no find license Plate": "找不到車牌",
        "IDAccess mode must be 0, 1, or 2.": "IDAccess模式必須是0、1或2。",
        "Run field is required when mode is 1 or 2.": "當模式為1或2時，運行欄位必填。",
        "Serial field is required when mode is 2.": "當模式為2時，序號欄位必填。",
        "the pin cannot be empty": "pin不能為空",
        "the rfCard cannot be empty": "rfCard不能為空",
        "the IDAccess already exist": "IDAccess已存在",
        "the resident cannot be empty": "住戶不能為空",
        "the fingerprint cannot be empty": "指紋不能為空",
        "the face cannot be empty": "人臉不能為空",
        "not found pin": "未找到pin",
        "not found rfCard": "未找到rfCard",
        "not found IDAccess": "未找到IDAccess",
        "not found fingerprint": "未找到指紋",
        "not found face": "未找到人臉",
        "face pic is invalid.": "臉部照片無效。",
        "community build and room cannot be empty.": "社區建築和房間不能為空。",
        "device info mac cannot be empty.": "設備資訊mac不能為空。",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "排程類型必須是0、1、2，或時間格式無效，或數據標誌不在0-127之間。",
        "MAC address cannot be empty.": "MAC地址不能為空。",
        "MAC address 0C1105000000 is not allowed.": "MAC地址0C1105000000不允許使用。",
        "MAC address must be 12 hexadecimal characters.": "MAC地址必須是12位十六進制字元。",
        "Scheduler type value is invalid.": "排程類型值無效。",
        "parse is fail": "解析失敗",
        "the fingerprint already exist": "指紋已存在",
        "the licensePlate cannot be empty": "車牌不能為空",
        "the licensePlate already exist": "車牌已存在",
        "idaccess run must be 10 digit number or end with -K.": "idaccess運行必須是10位數字或以-K結尾。",
        "idaccess serial must be 9 digit number.": "idaccess序號必須是9位數字。",
        "relay not in 0-15": "繼電器不在0-15範圍內",
        "security relay not in 0-3": "安全繼電器不在0-3範圍內",
        "file name is wrong": "檔案名錯誤",
        "access mode specified": "已指定訪問模式",
        "create community user accessmode failed.": "創建社區用戶訪問模式失敗。",
        "delete community user accessmode failed.": "刪除社區用戶訪問模式失敗。",
        "Cannot delete building because it has associated users.": "無法刪除建築物，因為有綁定用戶。",
        "Cannot delete building because it has associated Salto devices.": "無法刪除建築物，因為其已關聯 Salto 設備。",
        "community building not found": "未找到社區建築",
        "Invalid Name Display": "名稱顯示無效",
        "The Community does not exist.": "該社區不存在。",
        "Update CommunityIsInstallerKit Error.": "更新CommunityIsInstallerKit錯誤。",
        "Dis Not SupportCommunityCalls Error.": "代理商不支援社區呼叫錯誤。",
        "Community Has Special Device, Not Allowed To Delete.": "社區有特殊裝置，不允許刪除。",
        "The project smart home switch must be disabled": "專案智慧家庭開關必須禁用",
        "There are ITec Locks in project": "專案中有ITec鎖",
        "There are Salto Locks in project": "專案中有Salto鎖",
        "There are Dormakaba Locks in project": "專案中有Dormakaba鎖",
        "It is rent manager project": "這是rent manager專案",
        "It is installer account": "這是安裝商帳號",
        "contact preference type": "呼叫偏好類型",
        "Floor list is required when not all floors.": "非全樓層時需提供樓層清單。",
        "Building floors list is required when all buildings.": "全棟時需提供樓棟樓層清單。",
        "Indoor monitor name is required.": "室內機名稱必填。",
        "The primary account is not activated.": "主帳號未啟動。",
        "You can\'t create more family member accounts.": "您無法新增更多家庭成員帳號。",
        "community user not found": "未找到社區用戶",
        "community is empty": "社區為空",
        "the end user not master user": "終端用戶不是主帳戶用戶",
        "the end user not member user": "終端用戶不是從帳戶用戶",
        "The email already exists and cannot be repeated": "該電子郵件已存在，不能重複",
        "The mobile Number already exists": "手機號碼已存在",
        "The room number format error.": "房號格式錯誤。",
        "community not found": "未找到社區",
        "resident not found": "未找到居民",
        "installer not found": "未找到安裝商",
        "Operation Failed!": "操作失敗！",
        "You don\'t have operate permission": "您沒有操作許可",
        "You cannot select Relay and Door at the same time": "您不能同時選擇繼電器和門",
        "user don\'t active": "用戶未啟動",
        "User has expired": "用戶已過期",
        "timestamp must be within 3 minutes of current server time": "時間戳必須在當前伺服器時間3分鐘以內",
        "cannot find single rf Card.": "無法找到單一rf Card。",
        "cannot find community rf Card.": "無法找到社區rf Card。",
        "smartLock model": "智慧鎖型號",
        "the project does not open smart home": "該專案未啟用智慧家庭",
        "php web server error": "php網頁伺服器錯誤",
        "Ins not found.": "未找到Ins。",
        "RentManage Unit Not Set.": "未設定RentManage單位。",
        "add audit log error": "新增稽核日誌錯誤",
        "check building in error": "檢查樓棟時出錯",
        "Special devices cannot be deleted": "特殊裝置無法刪除",
        "the email is empty": "電子郵件為空",
        "the email format is incorrect": "電子郵件格式錯誤",
        "the mobile number is empty": "手機號碼為空",
        "the mobile number format is incorrect": "手機號碼格式不正確",
        "Site not found": "未找到專案",
        "User not found": "未找到使用者",
        "invalid time format": "時間格式無效",
        "ground floor type": "中間樓層格式",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "起始樓層範圍錯誤，有效值為-10到-1，G0，G1，G2，1至128。",
        "Building ID must be between 1 and 99.": "樓棟ID必須介於1~99之間。",
        "Community building name": "社區樓棟名稱",
        "Building ID already exists in this community.": "該社區已存在此樓棟ID。",
        "building ID": "樓棟ID",
        "Community building not found.": "未找到社區樓棟。",
        "Cannot delete building because it has associated devices.": "無法刪除建築物，因為有綁定裝置。",
        "project is not valid": "專案無效",
        "Cannot delete building because it has associated salto devices.": "無法刪除樓棟，因為有綁定salto設備。",
        "Cannot delete building because it has associated iTec devices.": "無法刪除建築物，因為有綁定iTec設備。",
        "Cannot delete building because it has associated dormakaba devices.": "無法刪除樓棟，因為有綁定dormakaba設備。",
        "member limit num": "成員限制數量",
        "Indoor Monitor No Set Error.": "室内机未设置错误。",
        "The room not has indoor": "房間沒有室內機",
        "check user in building error": "檢查用戶是否在建築錯誤中",
        "The name specified is already in use.": "該名稱已被使用。",
        "This timeblock overlaps with an existing one. Please adjust it.": "此時間區段與現有區段重疊。請進行調整。",
        "This door status changed. Please try again.": "該門狀態已變更。請重試。",
        "the lock can\'t bind this community": "該鎖無法綁定此社區",
        "The custom quantity limit has been exceeded!": "已超出自訂數量限制！",
        "This time span overlaps with an existing one. Please adjust it.": "此時間區間與現有區間重疊。請進行調整。",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "此一次性執行時間與現有的一次性執行時間有效期重疊。請進行調整。",
        "Operation Failed. Please try again.": "操作失敗。請再試一次。",
        "The image is not a front view.": "該圖片不是正面視圖。",
        "A mask was detected.": "偵測到口罩。",
        "The image resolution is too low.": "圖片解析度太低。",
        "No face was detected.": "未偵測到人臉。",
        "The file size is too large.": "檔案大小過大。",
        "The face in the image is too large.": "圖片中的臉太大了。",
        "The face in the image is too small.": "圖片中的臉太小了。",
        "Multiple faces detected.": "偵測到多個人臉。",
        "The face is not clear enough.": "臉部不夠清晰。",
        "Face detection failed.": "人臉偵測失敗。",
        "Please enter a value between 1 and 9999": "請輸入1到9999之間的數值",
        "Please select which input your door sensor is connected to.": "請選擇您的門磁感應器所連接的輸入端口。",
        "Add temp key failed, please try it again": "新增臨時密鑰失敗，請再試一次",
        "Dis Not Support Dynamic QRCode Error.": "不支援動態 QRCode 錯誤。",
        "QR code not exist": "QR code 不存在",
        "The temp key has expired.": "臨時密鑰已過期。",
        "The device is not in the office": "該設備不在辦公室",
        "The device is already assigned.": "該設備已被分配。",
        "The device cannot be assigned to any user.": "無法將該設備分配給任何使用者。",
        "You cannot select an option with fewer users than the current project members.": "您不能選擇用戶數量少於當前項目成員數量的選項。",
        "File check failed. Please download the latest template and try again.": "檔案檢查失敗。請下載最新模板並再次嘗試。",
        "Dynamic QR Code not active.": "動態 QR 碼未啟用。",
        "Dynamic QR Code not enable.": "未啟用動態 QR 碼。",
        "{0} not found.": "未找到{0}。",
        "Tier charge plan": "階梯收費方案",
        "Feature billing charge plan new": "功能計費方案新",
        "Feature billing gradient charge plan": "功能計費梯度收費方案",
        "The exit time cannot be earlier than the entry time.": "離開時間不能早於進入時間。",
        "User Name or Password": "使用者名稱或密碼",
        "You can only link up to 5 sites.": "您最多只能連結5個站點。",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "此車牌已註冊給一位住戶，無法加入黑名單。",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "該車牌已被列入封鎖名單，無法註冊為車輛。",
        "Elevator not configured in company access floor.": "電梯未在公司通行樓層中配置。",
        "the device is not in the office": "該設備不在辦公室",
        "A maximum of 1000 data items can be imported": "最多可以導入1000條數據項",
        "Exit time cannot be later than the current time.": "退出時間不能晚於當前時間。",
        "You can only import a file at a time in the current parking lot.": "在當前停車場，您每次只能導入一個文件。",
        "The license plate is already in the blocklist.": "車牌號已在黑名單中。",
        "Building name too long.": "樓棟名稱過長",
        "Unlock failed. Permission denied by user.": "解鎖失敗。使用者拒絕授權。",
        "Please remove the sensor device(s) before disabling this feature.": "請先移除感測器裝置，然後再停用此功能。",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "操作失敗！此使用者已超過每日15筆記錄的限制。",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "每個項目最多可新增 {0} 台公共設備。如需新增更多，請聯繫 Akuvox 技術支援：support{'@'}akuvox.com。",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "每個項目最多可新增 {0} 個員工帳號。如需新增更多，請聯繫 Akuvox 技術支援：support{'@'}akuvox.com。",
        "cancel": "取消",
        "bluetooth": "藍牙",
        "Battery Level": "電池電量",


    }
};
